export default __webpack_public_path__ + "static/media/bg51.1480c646.webp";